var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 7,
    viewBox: "0 0 11 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7812 1.42872L6.02812 6.75487C5.73645 7.08171 5.26355 7.08171 4.97188 6.75487L0.218757 1.42872C-0.0729189 1.10188 -0.0729189 0.571968 0.218757 0.245129C0.510432 -0.0817103 0.983331 -0.0817103 1.27501 0.245129L5.5 4.97949L9.72499 0.245129C10.0167 -0.0817099 10.4896 -0.0817099 10.7812 0.24513C11.0729 0.571969 11.0729 1.10188 10.7812 1.42872Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "v10/media/arrow.9596a499b7163b8f0886ed9b452a753b.svg";
export { ForwardRef as ReactComponent };